const initialState: sage.state.IOpen = {
    onLoginPath: null,
};

export default function open(
    state: sage.state.IOpen = initialState,
    action: sage.actions.open.ReducerTypes
): sage.state.IOpen {
    switch (action.type) {
        case "com.sage.actions.open.ISetOnLoginPath":
            return {
                ...state,
                onLoginPath: action.path,
            };
        default:
            return state;
    }
}
